import axios from "../../privateApi";

export const deleteSpecificPlayers = (eaPlayerIds: number[]) => {
  return axios.delete(`/user-players?ids=${eaPlayerIds.join(",")}`);
};
